import useGeoLocation from "../../../../../../../hooks/useGeoLocation";
import {
  copyClipboard,
  getKoreanNumber,
  getDistanceKm,
} from "../../../../../../../utils/common";
import { getGameTypeString } from "../../../../../../../utils/constants";
import { usePubContext } from "../../../../hooks/pub-context";
import {
  PremiumPubBannerInfoWrapper,
  PremiumPubBannerInfoHeader,
  PremiumPubBannerPubInfo,
  PremiumPubBannerInfoBoxWrapper,
  PremiumPubBannerInfoBottom,
  PremiumPubBannerInfoIconWrapper,
  PremiumPubBannerInfoPageWrapper,
} from "../../style";

interface PremiumPubBannerInfoProps {
  currentBannerIndex: number;
  total: number;
}

const PremiumPubBannerInfo = ({
  currentBannerIndex,
  total,
}: PremiumPubBannerInfoProps) => {
  const { data } = usePubContext();
  const { latitude, longitude } = useGeoLocation(true);

  const handleCopy = () => {
    if (!data) return;
    copyClipboard(data.newAddress + " " + data.detailAddress);
  };

  return (
    <PremiumPubBannerInfoWrapper>
      <PremiumPubBannerInfoHeader>
        <PremiumPubBannerPubInfo>
          <div className="name">{data?.cafeName}</div>
          <div className="address">
            {data?.newAddress} {data?.detailAddress}
            <img
              src="/image-web/pub/copy.svg"
              alt="copy"
              onClick={handleCopy}
            />
          </div>
          <PremiumPubBannerInfoBoxWrapper>
            <div className="box">
              {data && getGameTypeString(data?.gameTypes)}
            </div>
            {data?.buyIn && (
              <div className="box">
                바이인 : {getKoreanNumber(data.buyIn ?? 0)} ~{" "}
                {data?.buyInMax ? getKoreanNumber(data.buyInMax ?? 0) : ""}
              </div>
            )}
          </PremiumPubBannerInfoBoxWrapper>
        </PremiumPubBannerPubInfo>
        <div className="tag">
          <img src="/image-web/store/premium_badge.svg" alt="tag" />
          프리미엄
        </div>
      </PremiumPubBannerInfoHeader>
      <PremiumPubBannerInfoBottom>
        <PremiumPubBannerInfoIconWrapper>
          <div className="item">
            <img
              src="/image-web/store/Icon/Heart/small-white.svg"
              alt="heart"
            />
            {data?.likeCount.toLocaleString()}
          </div>
          <div className="item">
            <img
              src="/image-web/store/Icon/Map%20pin/small-white.svg"
              alt="map"
            />
            {getDistanceKm(
              latitude,
              longitude,
              data?.lat || 0,
              data?.lon || 0
            ).toLocaleString()}
            km
          </div>
        </PremiumPubBannerInfoIconWrapper>
        <PremiumPubBannerInfoPageWrapper>
          {currentBannerIndex}
          <span> / {total}</span>
        </PremiumPubBannerInfoPageWrapper>
      </PremiumPubBannerInfoBottom>
    </PremiumPubBannerInfoWrapper>
  );
};

export default PremiumPubBannerInfo;
